import { useCallback, useEffect, useState } from "react";
import { getDeviceIp } from "./requests";
import { INITIAL_DEVICE_STATE } from "./constants";

export const useDeviceData = () => {
  const [device, setDevice] = useState(INITIAL_DEVICE_STATE);

  const getDeviceDetails = useCallback(async () => {
    if (!device.ip) {
      try {
        const response = await getDeviceIp();
        setDevice((currentDevice) => ({
          ...currentDevice,
          ip: response.ip
        }));
      } catch (error) {
        const UNKNOWN_IP = "UNKNOWN";
        setDevice((currentDevice) => ({
          ...currentDevice,
          ip: UNKNOWN_IP
        }));
      }
    }
  }, [device]);

  useEffect(() => {
    getDeviceDetails();
  }, [getDeviceDetails]);

  return {
    device
  };
};
